import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const ACCENT = "#00bbcd";

/** Evita cerrar al pulsar fuera o Escape; solo Cancelar / X. */
export function guardComposeDialogClose(onClose) {
  return (_event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    onClose?.();
  };
}

export const composeDialogSlotProps = {
  backdrop: {
    sx: {
      backgroundColor: "rgba(160, 160, 160, 0.45)",
    },
  },
};

export function normalizeComposeText(html) {
  return String(html || "")
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, " ")
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<\/p>/gi, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function fieldChanged(current, baseline) {
  return String(current || "").trim() !== String(baseline ?? "").trim();
}

/** Hay contenido que se perdería al cerrar. */
export function hasComposeDraft({
  to = "",
  cc = "",
  bcc = "",
  subject = "",
  html = "",
  attachments = [],
  baseline = {},
}) {
  if ((attachments?.length || 0) > 0) return true;
  if (fieldChanged(cc, baseline.cc)) return true;
  if (fieldChanged(bcc, baseline.bcc)) return true;
  if (fieldChanged(to, baseline.to)) return true;
  if (fieldChanged(subject, baseline.subject)) return true;

  const currentPlain = normalizeComposeText(html);
  const baselinePlain = normalizeComposeText(baseline.html ?? "");
  if (currentPlain !== baselinePlain) return true;

  return false;
}

export function ComposeDiscardConfirmDialog({ open, onCancel, onConfirm }) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>¿Descartar borrador?</DialogTitle>
      <DialogContent>
        <Typography color="text.secondary">
          Tienes cambios sin enviar. Si cierras ahora, se perderá el contenido
          que has escrito.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} sx={{ color: ACCENT }}>
          Seguir escribiendo
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          sx={{ boxShadow: "none" }}
        >
          Descartar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
